/* tslint:disable */
/* eslint-disable */
/**
 * bi-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserAggregateOrganization
 */
export interface UserAggregateOrganization {
    /**
     * 
     * @type {string}
     * @memberof UserAggregateOrganization
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserAggregateOrganization
     */
    name: string;
}

/**
 * Check if a given object implements the UserAggregateOrganization interface.
 */
export function instanceOfUserAggregateOrganization(value: object): value is UserAggregateOrganization {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UserAggregateOrganizationFromJSON(json: any): UserAggregateOrganization {
    return UserAggregateOrganizationFromJSONTyped(json, false);
}

export function UserAggregateOrganizationFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAggregateOrganization {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function UserAggregateOrganizationToJSON(json: any): UserAggregateOrganization {
    return UserAggregateOrganizationToJSONTyped(json, false);
}

export function UserAggregateOrganizationToJSONTyped(value?: UserAggregateOrganization | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

